"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const escape_reg_exp_1 = require("../maps/escape_reg_exp");
exports.tokenPattern = (leftBracket, rightBracket) => {
    return "(" + escape_reg_exp_1.default(leftBracket) + ".+?" + escape_reg_exp_1.default(rightBracket) + ")";
};
exports.default = exports.tokenPattern;
//# sourceMappingURL=token_pattern.js.map